import { track } from "jiffy-analytics";
import debounce from "lodash.debounce";

import "./calculator-section.scss";

const SLIDER_SELECTOR = ".js-jiffytransfers-landing-v2-calculator-slider";
const SLIDER_INPUT_SELECTOR = ".js-jiffytransfers-landing-v2-calculator-slider-input";
const SLIDER_VALUE_SELECTOR = ".js-jiffytransfers-landing-v2-calculator-slider-value";
const SLIDER_THUMB_WIDTH = 26;

const HTV_SELECTOR = ".js-jiffytransfers-landing-v2-calculator-htv";
const JIFFY_PRODUCTION_SELECTOR = ".js-jiffytransfers-landing-v2-calculator-jiffy-production";
const CURRENT_REVENUE_SELECTOR = ".js-jiffytransfers-landing-v2-calculator-current-revenue";
const JIFFY_REVENUE_SELECTOR = ".js-jiffytransfers-landing-v2-calculator-jiffy-revenue";

const $getSliders = () => document.querySelectorAll(SLIDER_SELECTOR);
const $getSliderInputs = () => document.querySelectorAll(SLIDER_INPUT_SELECTOR);

const formatThousands = number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const recalculateValuePosition = ($input, $value) => {
  if (!$input) {
    return;
  }

  const min = parseFloat($input.min) || 0;
  const max = parseFloat($input.max) || 1;
  const percent = (($input.value - min) / (max - min)) * 100;

  // eslint-disable-next-line no-param-reassign
  $input.style.background = `linear-gradient(to right, #dd2672 0%, #dd2672 ${percent}%, #fff ${percent}%, #fff 100%)`;

  if ($value) {
    $value.classList.remove("hidden");
    // eslint-disable-next-line no-param-reassign
    $value.textContent = $input.value;
    // eslint-disable-next-line no-param-reassign
    $value.style.left = `calc(${percent}% - ${
      SLIDER_THUMB_WIDTH * (percent / 100) - SLIDER_THUMB_WIDTH / 2
    }px)`;
  }
};

const recalculateResults = () => {
  const values = {};
  $getSliderInputs().forEach($input => {
    values[$input.name] = parseInt($input.value, 10);
  });

  const currentHTV = values["hours-slider"] * values["htv-slider"];
  const jiffyProduction = values["hours-slider"] * 20;
  const currentRevenue = currentHTV * values["sales-slider"];
  const jiffyRevenue = jiffyProduction * values["sales-slider"];

  document.querySelector(HTV_SELECTOR).textContent = formatThousands(currentHTV);
  document.querySelector(JIFFY_PRODUCTION_SELECTOR).textContent = formatThousands(jiffyProduction);
  document.querySelector(CURRENT_REVENUE_SELECTOR).textContent = `$${formatThousands(
    currentRevenue
  )}`;
  document.querySelector(JIFFY_REVENUE_SELECTOR).textContent = `$${formatThousands(jiffyRevenue)}`;

  return [
    values,
    {
      currentHTV,
      jiffyProduction,
      currentRevenue,
      jiffyRevenue
    }
  ];
};

const trackSliderChange = debounce(values => {
  track("transfers_landing_calculator_change", {
    target: "Calculator changed",
    "T-shirts made/hour": values["htv-slider"],
    "Hours/month spent": values["hours-slider"],
    "price per t-shirt": values["sales-slider"]
  });
}, 5000);

const initSliders = () => {
  $getSliders().forEach($slider => {
    const $input = $slider.querySelector(SLIDER_INPUT_SELECTOR);
    const $value = $slider.querySelector(SLIDER_VALUE_SELECTOR);
    $input?.addEventListener("input", () => {
      recalculateValuePosition($input, $value);
      const [values] = recalculateResults();
      trackSliderChange(values);
    });
    recalculateValuePosition($input, $value);
    recalculateResults();
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initSliders();
});
